import React from 'react'
import { Helmet } from 'react-helmet'
import MegaHeader from '../components/MegaHeader/MegaHeader'
import ServicesPageBanner from '../components/services-page-banner/ServicesPageBanner'
import TrustedPartner from '../components/trustedPartners/TrustedPartner'
import OurServices from '../components/our-services/OurServices'
import NewTestimonials from '../components/new-testimonials/NewTestimonials'
import WhyChooseUs from '../components/why-choose-us/WhyChooseUs'
import NewCaseStudySection from '../components/new-case-study-section/NewCaseStudySection'
import CoverTheStack from '../components/coverthestack/CoverTheStack'
import SimpleModels from '../components/simpleEngagementModels'
import PioneeringChange from '../components/pioneeringChange/PioneeringChange'
import NewRoadMap from '../components/new-raodmap-section/NewRoadMap'
import TrendsInsights from '../components/trends-n-insights/TrendsInsights'
import FAQ from '../components/Fqas/FAQ'
import SoftwareCompanyCta from '../components/software-company-cta/SoftwareCompanyCta'
import Footer from '../components/footer/Footer'
import { generativeAiContent } from '../data/generative-ai-page-data'
import tabData from '../data/industryData'
import { useTranslation } from 'react-i18next'
import IntigrationIconsSection from '../components/integration-icons-section/IntigrationIconsSection'
import MegaMenu from '../components/MegaMenu/MegaMenu'

const GenerativeAi = () => {

    const { t: stackData } = useTranslation("aiDevelopmentPageContent");
    const coverTheStackData = stackData("aiDevCoverTheStackSection", {
        returnObjects: true,
    });

    return (
        <>
            <Helmet>
                <title>Generative AI Development Services & Solutions | Bitsclan</title>
                <meta
                    name="description"
                    content="Looking for a generative AI development company with expertise? Bitsclan’s generative AI development services build custom GenAI solutions with measurable ROI."
                />
            </Helmet>

            <MegaMenu />

            <ServicesPageBanner
                shortHeading={generativeAiContent?.bannerContent?.shortHeading}
                mainHeading={generativeAiContent?.bannerContent?.mainHeading}
                description={generativeAiContent?.bannerContent?.description}
            />

            <TrustedPartner />

            <OurServices
                buttonText="Talk to Our Generative AI Consultants"
                servicesCardsData={generativeAiContent?.generativeAiServices?.cardsData}
                shortHeading={generativeAiContent?.generativeAiServices?.shortHeading}
                mainHeading={generativeAiContent?.generativeAiServices?.heading}
                description={generativeAiContent?.generativeAiServices?.description}
            />

            <IntigrationIconsSection content={generativeAiContent?.generativeAiIntigration} />

            <WhyChooseUs
                heading={generativeAiContent?.whyUsContent?.heading}
                greenHeading={generativeAiContent?.whyUsContent?.greenHeading}
                shortHeading={generativeAiContent?.whyUsContent?.shortHeading}
                content={generativeAiContent?.whyUsContent?.content}
                stats={generativeAiContent?.whyUsContent?.stats}
                sectionImage={generativeAiContent?.whyUsContent?.image}
            />

            <NewTestimonials
                shortHeading={generativeAiContent?.testimonialData?.shortHeading}
                mainHeading={generativeAiContent?.testimonialData?.mainHeading}
                description={generativeAiContent?.testimonialData?.description}
                content={generativeAiContent?.testimonialData?.testimonials}
            />

            <NewCaseStudySection
                shortHeading={generativeAiContent?.caseStudyContent?.shortHeading}
                heading={generativeAiContent?.caseStudyContent?.heading}
                description={generativeAiContent?.caseStudyContent?.description}
            />

            <CoverTheStack
                shortHeading={"Generative AI Tech Stack"}
                whereStart={"Generative AI Models"}
                mainHeading={"Technology Backbone Behind Our Generative AI"}
                subHeading={"Bitsclan uses advanced frameworks, platforms, & tools to build powerful & scalable Generative AI solutions. We deliver reliable Generative AI tools for businesses seeking innovation & efficiency."}
                tabs={coverTheStackData?.tabs}
                tabItems={coverTheStackData?.tabItems}
            />

            <PioneeringChange
                tabData={tabData}
                serviceTags={[
                    { title: "Chat bots & Virtual Agents", link: "/ai-chatbot-development-services" },
                    { title: "AI Automation", link: "/ai-automation-agency" },
                    { title: "Generative AI", link: "/generative-ai-development-services" }
                ]}
                shortHeading="GenAI Development Services for Your Industry"
                greenHeading={" of Industries With Generative AI”"}
                mainHeading={"Shaping the Future"}
                content={
                    "Our Generative AI development services & solutions create long lasting competitive advantages & support diverse use cases across all major industries."
                }
            />

            <NewRoadMap roadmapContent={generativeAiContent?.roadmapContent} />

            <TrendsInsights
                category="ai-developmet"
                heading={generativeAiContent?.trendingInsights.heading}
                description={generativeAiContent?.trendingInsights.description}
            />

            <FAQ
                faqs={generativeAiContent.faqSection.questionAnswers}
                mainHeading={generativeAiContent.faqSection.heading}
            />
            <SoftwareCompanyCta content={generativeAiContent?.companyCta} />
            <Footer />
        </>
    )
}

export default GenerativeAi